<template>
  <div>
    <div
      class="grid"
      :class="large ? 'gap-6' : 'gap-2 xs:grid-cols-2 mx-auto'"
      :style="large ? {} : { 'max-width': '15rem' }"
    >
      <div v-show="showSocialButtons" class="contents">
        <LoginButton
          v-for="{ name, icon } in socials"
          :key="name"
          :label="name"
          :labelIntro="labelIntro"
          :large="large"
          class="text-white"
          :class="`btn-${name.toLowerCase()}`"
          :disabled="disabled"
          @click="$emit('continueWith', name)"
        >
          <component
            slot="icon"
            :is="icon"
            class="w-5 h-5"
            :class="large ? '' : 'xs:static'"
            :aria-hidden="true"
          />
        </LoginButton>
      </div>
    </div>
  </div>
</template>

<script>
import LoginButton from '@/components/Account/LoginButton'
import Facebook from '@/assets/svg/social/login/facebook.svg?inline'
import Google from '@/assets/svg/social/login/google.svg?inline'
import Skeleton from '@/components/loader/Skeleton'

export default {
  components: { LoginButton, Facebook, Google, Skeleton },

  props: {
    showSocialButtons: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    labelIntro: { type: String, default: 'Sign in with' },
  },

  data: () => ({
    socials: [
      { name: 'Google', icon: Google },
      { name: 'Facebook', icon: Facebook },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.btn-facebook {
  @apply bg-blue-600;

  &:hover {
    @apply bg-blue-500;
  }
  &:focus {
    @apply border-blue-700 shadow-outline-blue;
  }
  &:active {
    @apply bg-blue-700;
  }
}

.btn-google {
  @apply bg-red-600;

  &:hover {
    @apply bg-red-500;
  }
  &:focus {
    @apply border-red-700 shadow-outline-red;
  }
  &:active {
    @apply bg-red-700;
  }
}
</style>
